import { render } from "./ActivityList.vue?vue&type=template&id=48831b2a"
import script from "./ActivityList.vue?vue&type=script&lang=js"
export * from "./ActivityList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\external\\kazigraphix\\admin.kazigraphix\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__